export const partnerPortal_Url =

"https://cosmos.bajajfinservsecurities.in/partner-onboarding/api";

export const Partner_Portal ={
  GetSendOtp_Url: partnerPortal_Url + "/auth/sendOTP",
  GetVerifyOtp_Url: partnerPortal_Url + "/auth/verifyOTP",
  CreatePartner_Url: partnerPortal_Url+"/partner/",
  GetZipCode_Url: partnerPortal_Url + "/ext/pincode?pincode=",
  GetDocumentsList_Url: partnerPortal_Url+"/partner/documents",
  GetBankIfsc_Url: partnerPortal_Url + "/ext/ifsc?",
  GetImpsValidation_Url: partnerPortal_Url + "/partner/imps",
  GetKid_Url: partnerPortal_Url + "/partner/digilocker",
  GetResume_Url: partnerPortal_Url + "/partner/stage",
  GetLogin_Url: partnerPortal_Url + "/auth/login",
  GetEsign_Url: partnerPortal_Url + "/partner/esign",
  GetForgotPassword_Url: partnerPortal_Url + "/auth/forgotPassword",
  GetLead_Url: partnerPortal_Url+ "/partner/lead-capture",
  DIGIOKID: "https://digilocker.bajajfinservsecurities.in/?kid=",
 ESIGNID: "https://digilocker.bajajfinservsecurities.in/?type=partner-esign",
 PAYMENT_ESIGN: "cosmos.bajajfinservsecurities.in/partner/e-sign",

//  DIGIOKID: "https://cug-digilocker.bajajfinservsecurities.in/?kid=",
//  ESIGNID: "https://cug-digilocker.bajajfinservsecurities.in/?type=partner-esign",
//  PAYMENT_ESIGN: "cug-cosmos.bajajfinservsecurities.in/partner/e-sign",

}

